import styled from 'styled-components'

import { Button } from '@/UIkit/Button'

import { SignOutButton } from '../../components'
import { theme } from '../../theme'

export const FormSection = styled.div`
  margin-bottom: 2.5rem;
`

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const SectionTitle = styled.h2`
  font-family: ${theme.fonts.itcGothicPro};
  color: ${theme.colors.altovita};
  margin-bottom: 24px;

  font-weight: ${theme.fontWeight.semiBold};
  font-size: 20px;
  line-height: 24px;
`

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
`

export const SubmitButtonWrapper = styled.div`
  margin: 32px 0;
`

export const SubmitButton = styled(Button)`
  height: 56px;
`

export const MessageWrapper = styled.div`
  margin-top: 1.5rem;
`

export const SignoutSection = styled(SignOutButton)`
  margin-top: 16px;
`

export const OfficeMap = styled.img`
  height: 120px;
  border-radius: 16px;
  object-fit: cover;
`
